const PushHistoryAPI = {
    pagedList: {
        title: "푸시 발송 이력 목록 조회",
        url: "/PushHistory/PagedList",
        method: "POST" as const,
        paramz: {},
    },
}

export default PushHistoryAPI
